import PropTypes from "prop-types";
import React from "react";
import Generation from "app/components/Generation";

export default class RecursiveGeneration extends React.Component {
  render() {
    return (
      <Generation
        {...this.props}
        ref={(c) => {
          if (this.props.passthruRef) {
            this.props.passthruRef(c);
          }
        }}
      />
    );
  }
}
